import SubscriptionsIcon from '@mui/icons-material/CardMembership'
import SubscriptionList from './SubscriptionList'

export default {
  list: SubscriptionList,
  icon: SubscriptionsIcon
} 